import {defineStore} from 'pinia'

// @ts-ignore
export const useOrderStore = defineStore('order', {
  state: () => ({
    pathPrefix: '/order'
  }),
  getters: {},
  actions: {
    async postCart(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/cart`
      return await $apiClient(path, {
        method: 'POST',
        body: {
          type: payload.type,
          targetId: payload.targetId
        }
      })
    },
    async postOrder(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}`
      return await $apiClient(path, {
        method: 'POST',
        body: {
          type: payload.type,
          paymentType: payload.paymentType,
          name: payload.name,
          amount: payload.amount,
          memberAddressId: payload.memberAddressId,
          targetIds: payload.targetIds
        }
      })
    },
    async postOrderInvoice(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/invoice`
      return await $apiClient(path, {
        method: 'POST',
        body: {
          orderId: payload.orderId,
          name: payload.name,
          bizNo: payload.bizNo,
          email: payload.email,
          invoiceDate: payload.invoiceDate
        }
      })
    },
    async postOrderCashReceipt(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/cash-receipt`
      return await $apiClient(path, {
        method: 'POST',
        body: {
          orderId: payload.orderId,
          type: payload.type,
          receiptTargetNo: payload.receiptTargetNo
        }
      })
    },
    async getCartList() {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/cart`
      return await $apiClient(path, {
        method: 'GET'
      })
    },
    async getPreSignOrderInfo(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/pre-sign/${payload.orderType}`
      let query = `?targetIds=${payload.targetIds}`
      if (payload?.count) {
        query += `&count=${payload.count}`
      }
      if (payload?.memberType) {
        query += `&memberType=${payload.memberType}`
      }
      if (payload?.isNew){
        query += `&isNew=${payload.isNew}`
      }
      return await $apiClient(`${path}${query}`, {
        method: 'GET'
      })
    },
    async deleteCart(cartId) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/cart/${cartId}`
      return await $apiClient(path, {
        method: 'DELETE'
      })
    },
    async getOrderList(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/`
      const query = `?page=${payload.page}&limit=${payload.limit}`
      return await $apiClient(`${path}${query}`, {
        method: 'GET'
      })
    },
  }
})
